export const categoriesEndpoints = (builder) => {
  return {
    addCategory: builder.mutation({
      query: (name) => ({
        url: `/categories?name=${name}`,
        method: "post",
      }),
    }),
    deleteCategory: builder.mutation({
      query: (name) => ({
        url: `/categories?name=${name}`,
        method: "delete",
      }),
    }),
  };
};
